import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { openFullScreenModal } from "store/slices/common/fullScreenMedia.slice";
import { Avatar, Skeleton } from "@mui/material";

const SmartImage = ({
  src,
  alt = "image",
  fallback,
  className = "",
  showSkeleton = true,
  skeletonVariant = "circular",
  size,
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = useDispatch();

  // Reset when image source changes
  useEffect(() => {
    setHasError(false);
    setIsLoaded(false);
  }, [src]);

  const isInvalidSrc = !src || src.trim() === "";

  if (hasError || isInvalidSrc) {
    return fallback ?? null;
  }

  return (
    <div
      onClick={() =>
        dispatch(openFullScreenModal({ imageSrc: src, type: "image" }))
      }
      style={{ position: "relative", display: "inline-block", flexShrink: 0, height:size, width:size }}
    >
      {/* Show Skeleton while loading */}
      {!isLoaded && showSkeleton && (
        <Skeleton variant={skeletonVariant} sx={{ bgcolor: "rgba(0,0,0,0.2)" }}>
          <Avatar sx={{height:size, width:size}}/>
        </Skeleton>
      )}

      {/* Render image ONLY after loaded */}
      {src && (
        <img
          src={src}
          alt={alt}
          className={className}
          style={{
            display: isLoaded ? "block" : "none",
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 0.3s",
          }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
};

export default SmartImage;
